module.exports = __webpack_public_path__ + "static/yoox-com-02e4210fb3271c6abca243415224e6d1.png";